<template>
    <div class="  con_content  accounts">
        <div class="container">
            <div class="container_top h_48">
                发票管理
            
            </div>
            
            <!-- table组件 -->
            <div class="my_table" >
                <Header class="my_title txt_l" >
                    <span class="my_titleL">
                         <Icon class="fw_900 " type="ios-list" size='30'/>     
                        筛选查询
                    </span>
                   
                    
                </Header>
                <div class="my_search">
                    
                        
                         <Row class="search_row">  
                            <div  class="search_name">
                               用户账号:  
                            </div>              
                            <Col span="3">
                                <Input  ref='isFocuseA'    :maxlength='50'  class='ipt top13'  placeholder="用户ID/账号" @keyup.enter.native="accountFun" v-model="account" >
                                    <Button size="small" @click='accountFun'  slot="append" icon="md-search"></Button>
                                </Input>
                            </Col>
                    
                            <div  class="search_name">
                                用户昵称:
                            </div>
                            <Col span="3">
                                <Input  ref='isFocuseA'    :maxlength='50'  class='ipt top13'  placeholder="用户昵称" @keyup.enter.native="nameFun" v-model="name" >
                                    <Button size="small"  @click='nameFun'  slot="append" icon="md-search"></Button>
                                </Input>
                            </Col>
                            
                            <div  class="search_name">
                                申请时间:
                            </div>
                            <Col span="3">

                                <DatePicker ref='isFocuseC'   @on-change='createTimeFun' v-model="createTime"  type="date" placeholder="请选择时间"   clearable ></DatePicker>
                            </Col>
                                             

                            <div  class="search_name">
                                发票状态:
                            </div>                            
                            <Col span="3">
                               <Select   class='selectL'  v-model="state" placeholder='全部'  @on-change='stateFun'     clearable >
                                    <Option v-for="item in states"     :value="item.value" :key="item.value"  >{{ item.label }}</Option>
                                </Select>
                            </Col>

                        </Row>
                    
              
                    
                    
                </div>
               
              
            </div>
            <!-- table组件 -->
            <div class="my_table"  >
                <Header class="my_title txt_l">
                    <span class="my_titleL">
                        <Icon class="fw_900 " type="ios-list" size='30'/>     
                        数据列表
                    </span>
                    <div class="ct_rgt">
                        
                        <div class="sta_btn " type="primary"   @click="exportData">导出数据</div>
                        
                    </div>
                </Header>
                <Table   border :columns="columns1" :data="data1" ref='table'>
                    
                   
                    <!-- 按钮 -->
                    <template slot-scope="{ row, index }" slot="btn">
                        <Poptip trigger="hover" :title="row.name" content="查看">
                            <Button class='padlr5'  type="info"    icon="md-search" size="small" style="" @click="show(index,'/layout/caiwu/invoice/query')"></Button>
                        </Poptip>
                    </template>
                    
                </Table>
                <Footer>
                    <Page  :current.sync="page" :total="toatalPage" :page-size='pageSize'    @on-change='changepage'  show-total  show-elevator />
                </Footer>
        
            </div>
       </div>
       <!-- 操作 => 编辑 -->
        <Modal
           
            v-model="kp"
            :title="tan_title"
            width='750px'
            class-name="vertical-center-modal"
        >   


            <!-- 进度条 -->
            <Steps :current="stepNum">
                <Step title="开票详情" ></Step>
                <Step title="上传发票" ></Step>
                <Step title="完成开票" ></Step>
            </Steps>



            <!-- Modal 按钮 -->

            <!-- stepNum0 -->
            <div slot="footer" v-if='stepNum == 0'>
                <Button type='text' size='large' @click='kpFail0'>撤回</Button>
                <Button type='primary' size='large' @click='kpSucc0'>下一步</Button>
            </div>

            <!-- 下方内容 -->
            <div class="inv_con" v-if='stepNum == 0'>
               <div>
                   <div class="title fs16">
                        <Icon type="md-bookmark" />订单统计
                   </div>

                    <!-- table手写 -->
            
                    <table   class='table_content' border='0' width='100%' align='center' >
                        <tr>
                            
                            <td class='title'>发票抬头</td>
                            <td class='t_con' >{{list1.title}}</td>
                            <td class='title'>开票内容</td>
                            <td class='t_con relative' @click='ul_click'> 
                                <span v-if='list1.content'>{{list1.openingBank}}*{{fp_list.length}}</span>
                                <span v-if='!list1.content'>开票*{{fp_list.length}}</span>
                                <Icon type="md-arrow-dropdown"  class="rgt fs18"/>

                                <ul class="in_ul" v-if='ul_bool'>
                                    <li  v-for="item in fp_list">{{item}}</li>
                                </ul>
                            </td>
                            
                       
                        </tr>
                        <tr>
                            <td class='title'>发票类型</td>
                            <td class='t_con' v-if='list1.type == 0'>个人</td>
                            <td class='t_con' v-if='list1.type == 1'>企业</td>
                            <td class='title'>开票金额</td>
                            <td class='t_con'>￥{{ (list1.money/100).toFixed(2)}}</td>
                    
                        </tr>
                        <tr>
                            <td class='title'>税号</td>
                            <td class='t_con' v-if='list1.dutyParagraph'>{{list1.dutyParagraph}}</td>
                            <td class='t_con' v-if='!list1.dutyParagraph'>N/A</td>
                            
                            <td class='title'>收件人</td>
                            <td class='t_con'> {{list1.name}}</td>
                        </tr>
                        <tr>
                            
                            <td class='title'>电子邮箱</td>
                            <td class='t_con'>{{list1.email}}</td>
                            <td class='title'>收件电话</td>
                            <td class='t_con'>{{list1.mobile}}</td>
                        </tr>
                        <tr>
                            <td class='title'>电话、地址</td>
                            <td class='t_con'>{{list1.address}}</td>
                            <td class='title'>开户行及账号</td>
                            <td class='t_con' v-if='list1.openingBank'>{{list1.openingBank}}</td>
                            <td class='t_con' v-if='!list1.openingBank'>N/A</td>
                            
                        </tr>
                        
                    </table>
                  
               </div>
           </div>  
            <!-- stepNum1 -->
            <div slot="footer" v-if='stepNum == 1' >
                <Button type='text' size='large' @click='kpFail1'>返回</Button>
                <Button type='primary' size='large' @click='kpSucc1'>完成开票</Button>
            </div>

            <div class="inv_con   uploadH" v-if='stepNum == 1'>
                <Upload 
                    ref='up_ref'
                    :before-upload="bef_up"
                    action="https://api.jiapuji.vip/gateway/attached/service/attached/upload"
                    accept=".pdf"
                    :headers="headers"
                    :data="datas"
                    :on-success="imgFun"
                >   
                    <Button icon="ios-cloud-upload-outline" v-if='!pdfUrl'>上传发票</Button>
                     <div class="con_pdf" v-if='pdfUrl' @click.stop='pdfUrlNull'>
                        <div class="pdf" >
                            <pdf 
                                ref="pdf"
                                :src="pdfUrl">
                            </pdf>
                        </div>
                    </div>
                   
                </Upload>
               
               
                
                
                    <!-- 全屏观看-->
            
                <div class="pdf2" v-if='pdfUrl2' @click.stop='pdfUrl2Null'>
                    <pdf 
                        ref="pdf"
                        :src="pdfUrl">
                    </pdf>
                    <Icon class='icon' type="ios-close-circle" />
                </div>
                
                <Button  style='margin-top:10px;margin-right:10px;'  v-if='pdfUrl'   @click.stop='clear_img'  >清除图片</Button>
                <Button  style='margin-top:10px;' type='primary'  v-if='pdfUrl'   @click.stop='pdfUrl2Fun'  >全屏观看</Button>
            </div>
            <!-- stepNum2 -->
            <div slot="footer" v-if='stepNum == 2' >
                <Button type='text' size='large' @click='kpFail2'>查看项目</Button>
                <Button type='primary' size='large' @click='kpSucc2'>关闭</Button>
            </div>
            <div class="inv_con  " v-if='stepNum == 2'>
                <div style='width:100%;padding: 50px 0;'>
                    <Icon class="succ  txt_c" color='#19be6b' type="md-checkmark-circle" />
                    <p class='fs18 txt_c fw900'>开票成功</p>
                   
                </div>
                
            </div>
            
        </Modal>
        <!-- 撤回发票 -->
        <Modal       
            v-model="ch"
            title="撤回发票"
            width='750px'
            class-name="vertical-center-modal"
            
            @on-cancel="ch_cancel"
            @on-ok="ch_ok"
        >  
            <div slot="footer" >
                <Button type='text' size='large' @click='ch_cancel'>取消</Button>
                <Button type='primary' size='large' @click='ch_ok'>确认</Button>
            </div>
            <div class="inv_con1 ch_tan" >   
                <Icon style="transform:rotate(180deg);" class="fail  txt_c" color='#ff9900' type="md-information-circle" />
                <p class="f_p1 txt_c fw900 fs18">注意! 请谨慎撤回</p>
                <p class="f_p2 txt_c  fs12">撤回后发票状态为失败状态</p>
            </div>
            <div class="bz">
                <div class="bz_all bz_L fs16"> <span class="cRed">*</span> 备注 :</div>
                <div class="bz_all bz_R">
                    <Input v-model="content" type="textarea" :rows="6" placeholder="请输入备注信息" />
                </div>
            </div>
        </Modal> 



        <!-- 查看发票 -->
        <Modal
            v-model="ck"
            :title="ck_title"
            width='750px'
            class-name="vertical-center-modal"   
        >  
        <div slot="footer" > 
            <Button type='primary' size='large' @click='ok'>确认</Button>
        </div>
        <!-- 下方内容 -->
        <div class="inv_con" style="overflow:hidden;overflowY:scroll;height:600px;" >
            <div class="overflow:hidden">
                <div class="title fs16">
                    <Icon type="md-bookmark" />订单统计
                </div>

                <!-- table手写 -->
        
                <table   class='table_content' border='0' width='100%' align='center' >
                    <tr>
                        
                        <td class='title'>发票抬头</td>
                        <td class='t_con' >{{list1.title}}</td>
                        <td class='title'>开票内容</td>
                        <td class='t_con relative' @click='ul_click'> 
                            <span v-if='list1.content'>{{list1.openingBank}}*{{fp_list.length}}</span>
                            <span v-if='!list1.content'>开票*{{fp_list.length}}</span>
                            <Icon type="md-arrow-dropdown"  class="rgt fs18"/>

                            <ul class="in_ul" v-if='ul_bool'>
                                <li  v-for="item in fp_list">{{item}}</li>
                            </ul>
                        </td>
                        
                    
                    </tr>
                    <tr>
                        <td class='title'>发票类型</td>
                        <td class='t_con' v-if='list1.type == 0'>个人</td>
                        <td class='t_con' v-if='list1.type == 1'>企业</td>
                        <td class='title'>开票金额</td>
                        <td class='t_con'>￥{{ (list1.money/100).toFixed(2)}}</td>
                
                    </tr>
                    <tr>
                        <td class='title'>税号</td>
                        <td class='t_con' v-if='list1.dutyParagraph'>{{list1.dutyParagraph}}</td>
                        <td class='t_con' v-if='!list1.dutyParagraph'>N/A</td>
                        
                        <td class='title'>收件人</td>
                        <td class='t_con'> {{list1.name}}</td>
                    </tr>
                    <tr>
                        
                        <td class='title'>电子邮箱</td>
                        <td class='t_con'>{{list1.email}}</td>
                        <td class='title'>收件电话</td>
                        <td class='t_con'>{{list1.mobile}}</td>
                    </tr>
                    <tr>
                        <td class='title'>电话、地址</td>
                        <td class='t_con'>{{list1.address}}</td>
                        <td class='title'>开户行及账号</td>
                        <td class='t_con' v-if='list1.openingBank'>{{list1.openingBank}}</td>
                        <td class='t_con' v-if='!list1.openingBank'>N/A</td>
                        
                    </tr>
                    
                </table>
                <div    class="inv_con   table_02">
                    <div class="title fs16">
                        <Icon type="md-bookmark" />开票信息
                    </div>

                    <!-- table手写 -->
            
                    <table   class='table_content' border='0' width='100%' align='center' >
                        <tr>
                            
                            <td class='title'>发票状态</td>
                            <td class='t_con' v-if='list1.state == 0'>未开票</td>
                            <td class='t_con' v-if='list1.state == 1'>未开票</td>
                            <td class='t_con' v-if='list1.state == 2'>已开票</td>
                            <td class='t_con' v-if='list1.state == 3'>开票失败</td>
                           
                    
                        </tr>
                        <tr>
                            <td class='title'>开票人员</td>
                            <td class='t_con' v-if='list1.examineName'>{{list1.examineName}}</td>
                            <td class='t_con' v-if='!list1.examineName'>N/A</td>
                         
                           
                    
                        </tr>
                        <tr>
                            <td class='title'>开票时间</td>
                            <td class='t_con' v-if='list1.createTime'>{{list1.createTime}}</td>
                            <td class='t_con' v-if='!list1.createTime'>N/A</td>
                            
                        </tr>
                        <tr  v-if='ck_title != "已开票详情"'>
                            
                            <td class='title'>备注</td>
                            <td class='t_con' v-if='list1.content'>{{list1.content}}</td>
                            <td class='t_con' v-if='!list1.content'>无</td>
                          
                        </tr>
                        
                        
                    </table>
                    <div style="width:100px;height:15px"></div>
                </div>
                <div>
                    <pdf 
                        ref="pdf"
                        :src="list1.image"
                        style="width:100%"
                    >
                    </pdf>
                </div>
               
            </div>
        </div>  
                
    </Modal> 


            
            
       
  </div>
</template>

<script>
    import pdf from 'vue-pdf'

    export default {
      
        name:'invoice',
        components:{pdf},
        data () {
            return {
                token:'',
                checkGuid:'',
                checkGuid2 :'',


                // table
                total:null,
                columns1:[],
                data1:[],
                toatalPage:0,
                page:1,
                pageCurrent:1,
                pageSize:20,
       
                
              
                // 搜索
                account: '',
                name: '',
                createTime: '',
                // 搜索发票状态
                state:'',
                states:[
                    {value:'0',label:'未开票'},
                    // {value:'1',label:'待审核'},
                    {value:'2',label:'已开票'},
                    {value:'3',label:'开票失败'}
                
                ],

                kp:false,      //是否弹 步骤弹窗
                tan_title: '未开票详情',
                stepNum:0,
                list1:[],

                ch:false,    //撤回弹窗

                ck:false,    //查看弹窗
                content:"",

                headers:null,
                datas:null,

                img:null,          //上传后图片路径
                img_src:null,    //传后台的图片路径
                fp_guid:null,
                fp_list:[],
                ul_bool:false,

                ad_name: null,   //操作人员

                ck_title: null,

                pdfUrl:"",
                pdfUrl2:false,     //鼠标移入

             
            }
        },
       
         watch:{
             kp(val){
                var that = this;
                if(val == false){
                    that.stepNum = 0;
                   
                }
            },
            stepNum(val){
                var that = this;
                switch (val) {
                    case 0:
                        that.tan_title = '未开票详情'
                        break;
                    case 1:
                        that.tan_title = '上传发票'
                        break;
                    case 2:
                        that.tan_title = '开票完成'
                        break;
                
                    default:
                        break;
                };
                if( val != 1){
                    that.pdfUrl = null;
                    that.pdfUrl2 = false;
                    this.img_src = null;
                    this.img = null;
                }
             
               
            }
            
        },
        
        computed: {
          
            
        },
       
        methods: {
           load(){
                var that = this;
                 // vuex
               
               

                
                
                var mUrl = 'admin/service/admin/invoice/all?page=' + that.page + '&account=' + that.account + '&name=' + that.name + '&createTime=' + that.createTime + '&state=' + that.state;
                

                that.$ajax({
                
                    method:'get',
                    url: mUrl,
                    data: {},
                    
                }).then(res => {
                        
                    var total = res.data.data;
                    var list =res.data.data.list;
                    // console.log('loginLog',total,list)
                    that.total = total;
                    var len = list.length;
                    
                        
                    that.columns1 = [
                        // {type:'selection',width:50,align:'center'},
                        {title:'用户ID',key:'number',align:'center'},
                        {title:'用户账号',key:'mobile',align:'center'},
                        {title:'用户昵称',key:'name',align:'center',},
                        {title:'订单数',key:'orderIds',align:'center',},
                        {title:'开票类型',key:'type',align:'center',},
                        {title:'开票总金额',key:'money',align:'center',minWidth:150},
                        {title:'申请时间',key:'createTime',align:'center'},
                        {title:'操作人员',key:'adminName',align:'center'},
                        {title:'操作时间',key:'examineTime',align:'center'},
                        {title:'发票状态',key:'state2',align:'center'},
                        {title:'操作',slot:'btn',align:'center',fixed: 'right'}
                        
                    ];

                    
                  
                    for(var i=0;i<len;i++){
                        //  订单金额 
                        list[i].money = '￥'+ (list[i].money/100).toFixed(2);
                        //   发票状态
                        
                        if(list[i].state == 0){
                            list[i].state2 = '未开票';
                        }else if(list[i].state == 1){
                            list[i].state2 = '未开票';
                        }else if(list[i].state == 2){
                            list[i].state2 = '已开票';
                        }else{
                            list[i].state2 = '开票失败';
                        }

                       
                        // 发票类型
                        if(list[i].type == 0){
                            list[i].type = '个人发票';
                        }else if(list[i].type == 1){
                            list[i].type = '企业发票';
                        }

                        //  操作人员
                        if(!list[i].adminName){
                           list[i].adminName = 'N/A' 
                        }

                        //  对账时间 
                        if(!list[i].examineTime){
                           list[i].examineTime = 'N/A' 
                        }

                        // 订单数
                        
                        list[i].orderIds =  list[i].orderIds.split(",");
                      
                        // console.log(list[i].orderIds);

                        list[i].orderIds = list[i].orderIds.length;
                       
                    }
                  


                    that.data1 = list;

                    that.toatalPage = total.total;
                    that.pageSize = total.pageSize;
                    
                    // console.log('data1',that.data1)
                    
                }).catch(err=>{
                    console.log(err)
                })

              
           },
          
           tanLoad(guid){
                var that = this;
                // var mUrl = 'admin/service/admin/invoice/guid?guid=' + 'adc4b3eecb0b11e9a79600163f00f444' ;
                var mUrl = 'admin/service/admin/invoice/guid?guid=' + guid +'&route=' +that.route;
                

                that.$ajax({
                
                    method:'get',
                    url: mUrl,
                    data: {},
                    
                }).then(res => {
                    that.list1 = res.data.data;
                    that.fp_list = res.data.data.orderIds.split(",");
                    
                   
                  
                   
                })
           },
           
           changepage(index){
               var that = this;
               that.load();
           },



            // 用户账号
            accountFun(val){
                var that = this;
               
                that.page = 1;
             
                that.name = '';
                that.createTime = '';
                that.state = '';


                that.load();
               
            },
            // 用户昵称
            nameFun(){
                var that = this;
               
                that.page = 1;
                that.account = '';
               
                that.createTime = '';
                that.state = '';


                that.load();

            },
             //    注册时间
            createTimeFun(val){
               var that = this;

                that.createTime = val;

                that.page = 1;
                that.account = '';
                that.name = '';
                
                that.state = '';


                that.load();
           },
         
            // 对账状态
            stateFun(){
                var that = this;
                

                that.page = 1;
                that.account = '';
                that.name = '';
                that.createTime = '';
               

                that.load();
            },
           

      
           //导出数据
           //    导出
            exportData(){
                var that = this;
                that.$refs.table.exportCsv({
                    filename: '发票管理',
                    original: false
                });
               
            },

            // 弹窗
            show(data,route){
                var that = this;
                that.route = route;

                that.$canBtn(that.route).then( function(res){
                    var checkGuid2 = that.data1[data].guid;
                    that.checkGuid2 = checkGuid2; 
                    
                    that.$store.commit('change_checkGuid2',checkGuid2);
                    if(that.data1[data].state == 0 || that.data1[data].state == 1){
                        that.kp = true;
                        that.ck_title = '未开票详情';
                    }else if(that.data1[data].state == 2){
                        that.ck = true;
                        that.ck_title = '已开票详情';
                    }else{
                        that.ck = true;
                        that.ck_title = '开票失败详情';
                    }
                    that.tanLoad(checkGuid2);
                })
                
            },


            kpFail0(){
                var that = this;
                that.kp = false;
                that.ch = true;
            },
            kpSucc0(){
               var that = this;
               that.stepNum = 1; 
            },
            kpFail1(){
                var that = this;
                that.stepNum = 0;
            },
            kpSucc1(){       //完成开票
                var that = this;
                var mUrl = 'admin/service/admin/invoice/examine?route=/layout/caiwu/invoice/send';
                if(that.img_src){
                     that.$ajax({
            
                        method:'post',
                        url: mUrl,
                        data: {
                            guid: that.checkGuid2,
                            state: 2,
                            image: that.img_src
                            
                        },
                      
                    }).then(res => {
                        that.$alert.info(res);
                        
                        
                        that.stepNum = 2;
                        that.load();
                        
                    })
                }else{
                    that.$alert.info('请上传发票');
                    
                }
               
             
                 
            },
            kpFail2(){
                var that = this;
                that.ck = true;
                that.kp = false;
                that.ck_title = '已开票详情';
            },
            kpSucc2(){
               var that = this;
               that.kp = false;
               
            },


            // 撤回
            ch_ok(){
                var that = this;
                var mUrl = 'admin/service/admin/invoice/examine';
                 
                if( that.content ){     //备注不为空
                   that.$ajax({
                
                        method:'post',
                        url: mUrl,
                        data: {
                            guid: that.checkGuid2,
                            state: 3,
                            content: that.content
                        },
                       
                    }).then(res => {
                        that.load();
                        that.ch = false;
                    })
                    
                }else{
                    that.$alert.info('请填写备注');
                    
                }
            },
            ch_cancel(){
                this.ch = false;
            },
            
            ok(){
                this.ck = false;
            },
            cancel(){

            },



            imgFun(data){
                var that = this;
                // console.log(data.data);
                that.img = data.data.path;
                that.img_src = data.data.name;
                that.pdfUrl = data.data.path;
            },

            // 弹窗0的下拉菜单
            ul_click(){
                var that = this;
                that.ul_bool = !that.ul_bool;
            },
            pdfUrl2Fun(){
                this.pdfUrl2 = true;
            },
            pdfUrl2Null(){
                this.pdfUrl2 = false;
            },
            pdfUrlNull(){

            },
            // 清除图片
            clear_img(){
                this.pdfUrl = null;
                this.img_src = null;
                this.img = null;
                
            },
            bef_up(){
                this.$refs.up_ref.clearFiles()
            }
              


        },
        mounted: function(){
            var that = this;
            that.token = that.$store.state.token;
            that.checkGuid = that.$store.state.checkGuid;
            that.checkGuid2 = that.$store.state.checkGuid2;
            that.headers = {
                'Authorization':'Bearer ' + that.token
               
            };
            that.datas = {
                guid: that.checkGuid,
                type: 5
            };
            that.load();
           
           
            
        }
       
    }
</script>
<style scoped>
    @media screen and (min-width:1120px){
      .my_search .search_name{
          margin-left: 20px;
          margin-right: 20px;
      }  
    }
    @media screen and (max-width:1119px){
      .my_search .search_name{
          margin-left: 10px;
          margin-right: 10px;
      }
      .my_search .search_name:first-child{
          margin-left: 20px;
      }
    }
   

    /* 弹窗底部(除进度条) */
    .inv_con{
        /* height: 300px; */
        width: 100%;
        margin-top: 20px;
        margin-bottom: 10px;
    }
    .inv_con1{
        /* height: 300px; */
        width: 100%;
       
        margin-bottom: 10px;
    }
    .ch_tan p{
        padding: 5px;
    }
    .ch_tan p:last-child{
        color: gray;
    }
    .succ{
        width: 100%;
        height: 150px;
        line-height: 150px;
        font-size: 150px;
      
    }
    .fail{
        width: 100%;
        height: 160px;
        line-height: 160px;
        font-size: 150px;
      
    }
    /* 撤回 */
    .f_p1{
        
    }
    .f_p1{

    }
    .bz{
        width: 100%;
        height: auto;
        overflow: hidden;
    }

    .bz_all{
        float: left;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .bz_L{
        width: 15%;
        text-align: right;
        padding-right: 15px;
    }
    .bz_R{
        width:85%;
        height: auto;
        overflow: hidden;
    }

    /* 弹窗0，下拉列表 */
    .in_ul{
        position: absolute;
        left: 0;top:48px;
        width: 100%;
        height: 170px;
        overflow-y: scroll;
        background: white;
        border: 1px solid #f1f1f1;
        
    }
    .in_ul li{
        width: 100%;
        height: 35px;
        line-height: 35px;
      
        padding-left: 10px;
    }
    
    .uploadH{
        padding: 20px 0 10px;
    }

    /* 开票信息table */
    .table_02 .t_con{
        width: 84%!important;
    }
    .con_pdf{
     
        width: 718px;
        height: 425px;
        overflow-y: auto;
    }
    /* .con_pdf::-webkit-scrollbar {
       width: 0 ;height: 0;
    }  */

    .pdf{
      
        width: 100%;
    }
    .pdf>span{
        width: 100%;
    }
    /* 鼠标移入 */
    .pdf2{
        position: fixed;
        top:0;bottom:0;left: 0;right:0;
        margin:auto;
        width: 1000px;
        height:auto;
        z-index: 999999;
        overflow-y: scroll;
    }
    .pdf2>span{
        width: 100%;
    }
    .pdf2 .icon{
        position: absolute;
        right: 30px;
        top: 30px;
        font-size: 30px;
        color: #ed4014;
    }
</style>



